// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GraduatedProgressChart from './SecurityDashboardProgressChart';
// css
import '../../styles/components/analytics/SecurityDashboardsOverviewCategory.scss';


class SecurityDashboardsOverviewCategory extends Component {

  renderContent() {
    const { category } = this.props;

    if (this.hasSubcategories()) {
      return this.renderSubcategories();
    }
    return this.renderChart(0, category.dashboards);
  }

  renderChart(key, dashboards, title = '') {
    return (
      <GraduatedProgressChart
        key={key}
        title={title}
        dashboards={dashboards}
      />
    );
  }

  renderSubcategories() {
    const { subcategories } = this.props.category;
    return subcategories.map((subcategory, index) => (
      this.renderChart(index, subcategory.dashboards, subcategory.title)
    ));
  }

  hasSubcategories() {
    return !! this.props.category.subcategories;
  }

  getDashboardsCount() {
    if (this.hasSubcategories()) {
      return this.props.category.subcategories
        .reduce((acc, subcategory) => acc + subcategory.dashboards.length, 0);
    }
    return this.props.category.dashboards.length;
  }

  getTitle() {
    const { category } = this.props;
    if (this.getDashboardsCount() > 1) {
      return [category.title, 'Dashboards'].join(' ');
    }
    return [category.title, 'Dashboard'].join(' ');
  }

  render() {
    return (
      <div className='analytics__security-dashboards-overview-category'>
        <h4>{this.getTitle()}</h4>
        {this.renderContent()}
      </div>
    );
  }
}

SecurityDashboardsOverviewCategory.propTypes = {
  category: PropTypes.object.isRequired
};

export default SecurityDashboardsOverviewCategory;



// WEBPACK FOOTER //
// ./src/components/analytics/SecurityDashboardsOverviewCategory.js